import React from 'react';
import { bool, number, object } from 'prop-types';
import FormGigItems from '../FormGigItems';

const CheckoutFormItems = ({
    gigId,
    isSingle,
    selectedPackageId,
    isMilestoneOrder,
    isFiverrChoice,
    isRisingTalent,
    quantity,
    isRecurringOrderSelected,
    selectedRecurringOption
}) => (
    <>
        <input type="hidden" name="packages[gig_id]" value={gigId}/>
        <input type="hidden" name="packages[package_id]" value={selectedPackageId}/>
        <input type="hidden" name="packages[milestones_purchase]" value={isMilestoneOrder}/>
        <input type="hidden" name="fiverr_choice" value={isFiverrChoice}/>
        <input type="hidden" name="rising_talent" value={isRisingTalent}/>
        {!!isSingle &&
            <>
                <input type="hidden" name="gig_id" value={gigId}/>
                <input type="hidden" name="quantity" value={quantity}/>
            </>
        }
        {isRecurringOrderSelected &&
        <input type="hidden" name="packages[recurring_option_id]"
            value={selectedRecurringOption.id}/>
        }
        <FormGigItems packageId={selectedPackageId}/>
    </>
);

CheckoutFormItems.propTypes = {
    selectedPackageId: number.isRequired,
    gigId: number,
    isSingle: bool,
    isMilestoneOrder: bool,
    isRisingTalent: bool,
    isFiverrChoice: bool,
    quantity: number,
    isRecurringOrderSelected: bool,
    selectedRecurringOption: object
};

export default CheckoutFormItems;
